import styled from 'styled-components';
import AddItemIcon from 'components/AddItem';

export const AddItemContainer = styled.div`
    position: absolute;
    right: 15px;
    top: 10px;
    cursor: pointer;
    transform: scale(2.0) !important;
    &:hover{
        &>svg{
            opacity: 1;
        }
    }
    &:active{
        &>svg{
            opacity: 0.8;
        }
    }
    &>svg{
        width: 14px;
        opacity: 0.8;
    }
`;

export const AddItem = styled(AddItemIcon)`
    
`;

export const ItemElementContainer = styled.div`
    height: 200px;
    width: 228px;
    height: 358px;
    padding: 10px;
    @media only screen and (max-width: 768px) {
        height: 350px;
    }
    @media only screen and (max-width: 767px) {
        width: 50%;
    }
`;

export const Item = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    background-color: magenta;
    padding: 10px;
    background: linear-gradient(210.55deg, #353A40 -3.02%, #121416 93.08%);
    box-shadow: 36px 12px 64px rgba(2, 3, 3, 0.7), -12px -20px 56px rgba(232, 237, 243, 0.05), inset -16px -6px 80px rgba(248, 249, 249, 0.03);
    border-radius: 10px;
    overflow-y: hidden;
`;

export const Title = styled.div`
    min-height: 40px;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 100%;
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    color: #D6E1EF;
    width: 80%;
    cursor: pointer;
    @media only screen and (max-width: 768px) {
        font-size: 15px;
    }
`;

export const Image = styled.div`
    width: 120%;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: url(${({src})=> src});
    padding-top: 70%;
    box-sizing: border-box;
    margin: 5px 0px;
    margin-top: 20px;
    margin-left: -10%;
    cursor: pointer;
`;

export const Price = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 24px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: right;
    color: #D6E1EF;
    margin-top: 20px;
`;

export const Description= styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 130%;
    letter-spacing: 0.02em;
    font-feature-settings: 'ordn' on, 'cpsp' on;
    color: #D6E1EF;
    text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
    max-height: 70px;
    overflow-y: hidden;
    @media only screen and (max-width: 768px) {
        font-size: 12px;
    }
`;

export const SeeMoreButton = styled.div`
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 12px;
    line-height: 130%;
    display: flex;
    align-items: center;
    letter-spacing: 0.02em;
    font-feature-settings: 'ordn' on, 'cpsp' on;
    color: rgba(214, 225, 239, 0.8);
    text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
    margin-left: auto;
    width: 70px;
    margin-top: 10px;
    opacity: 0.7;
    cursor: pointer;
    &:hover{
        opacity: 1;
    }
`;